// src/unicodex_ui/admin/services/adminAuditApi.js
import adminApi from "./adminApiClient";

/**
 * Fetch audit logs
 * @param {object} params
 * @param {number} [params.limit]
 * @param {number} [params.offset]
 */
export async function fetchAuditLogs(params = {}) {
  const { limit = 50, offset = 0 } = params;
  const res = await adminApi.get("/api/admin/audit-logs", {
    params: { limit, offset },
  });
  return res.data; // { ok, items: [...] }
}

/**
 * Fetch risk events
 * @param {object} params
 * @param {number} [params.limit]
 * @param {number} [params.offset]
 * @param {string} [params.module]
 * @param {string} [params.severity]
 */
export async function fetchRiskEvents(params = {}) {
  const { limit = 50, offset = 0, module, severity } = params;

  const query = { limit, offset };
  if (module) query.module = module;
  if (severity) query.severity = severity;

  const res = await adminApi.get("/api/admin/risk-events", {
    params: query,
  });
  return res.data; // { ok, items: [...] }
}
